export default "__VITE_ASSET__821ad4c6__"